"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddressValid = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const utils_1 = require("./");
const src_1 = require("..");
function isAddressValid(firstName, lastName, addressLine1, addressLine2, city, postalCode, countryKey, provinceKey, type) {
    return __awaiter(this, void 0, void 0, function* () {
        const { country, province } = (0, utils_1.getCountryAndProvince)(countryKey, provinceKey);
        if (!country
            || (type === 'shipping' && !country.valid_for_shipping)
            || (type === 'billing' && !country.valid_for_billing)) {
            return false;
        }
        if (country.show_province) {
            if (!province
                || (type === 'shipping' && !province.valid_for_shipping)
                || (type === 'billing' && !province.valid_for_billing)) {
                return false;
            }
        }
        const validateRes = yield (0, checkout_frontend_library_1.validateAddress)(firstName, lastName, addressLine1, addressLine2, city, postalCode, (province === null || province === void 0 ? void 0 : province.name) || '', (province === null || province === void 0 ? void 0 : province.iso_code) || '', country.name, country.iso_code, '', (0, utils_1.getPhoneNumber)(), src_1.API_RETRY);
        return validateRes.success;
    });
}
exports.isAddressValid = isAddressValid;
